import request from '@/utils/httpClient'
// CustomerCompanyTicketTitle
// 获取列表
export function getCompanyTicketTitleList(params?: object) {
  return request({
    url: 'customerCompanyTicketTitle/page',
    method: 'get',
    params
  })
}

// 获取详情
export function getCompanyTicketTitleById(id: number) {
  return request({
    url: `customerCompanyTicketTitle/${id}`,
    method: 'get'
  })
}

// 批量删除
export function deleteCompanyTicketTitleById(id: number) {
  return request({
    url: `customerCompanyTicketTitle/${id}`,
    method: 'delete'
  })
}

// 获取审批列表
export function getReviewCompanyTicketTitleList(params?: object) {
  return request({
    url: 'customerCompanyTicketTitle/review/page',
    method: 'get',
    params
  })
}

// 获取修改审批信息
export function reviewCompanyTicketTitleById(id: number) {
  return request({
    url: `customerCompanyTicketTitle/review/${id}`,
    method: 'get'
  })
}

// 通过审批
export function reviewApproveTicketTitle(id: number, data?: object) {
  return request({
    url: `customerCompanyTicketTitle/${id}/actions/review/approve`,
    method: 'put',
    data
  })
}

// 通过拒绝
export function reviewRejectTicketTitle(id: number, data?: object) {
  return request({
    url: `customerCompanyTicketTitle/${id}/actions/review/reject`,
    method: 'put',
    data
  })
}

// 设置默认开票信息
export function setDefaultTicketTitle(id: number) {
  return request({
    url: `customerCompanyTicketTitle/${id}/actions/defaultContact`,
    method: 'put'
  })
}
